import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { DropzoneArea } from 'material-ui-dropzone';
import { TextField } from '@mui/material';
import useRequest from '../../../../Hooks/useRequest';
import { StyledButton } from '../../../../Components/Generics.styled';

const UploadAdContainer = styled.div`
    margin-top: 100px;
    display: flex;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const UploadAdSection = styled.div`
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const UploadAdInput = styled.div`
    max-height: 100%;
    width: 500px;
    margin-left: auto;
    margin-right: auto;

    .MuiDropzonePreviewList-image {
        max-width: none;
        object-fit: cover;
        height: 100%;
    }

    .MuiDropzonePreviewList-imageContainer {
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        max-width: none;
    }

    .MuiDropzoneArea-root {
        width: 100%;
        height: 100%;
        background-color: #fafbf7;
    }

    .MuiDropzoneArea-active {
        background-color: #2e69fe;
    }
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    text-align: center;
`;

const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    max-width: 200px;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
`;

const BackBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;
    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

const FileSizeErrorNotif = styled.div`
    width: 800px;
    margin-top: 50px;
    color: red;
`;

const UploadAd = (props) => {
    const {
        campaignData,
        setCampaignData,
        handleNavButtonBack,
        handleNavButtonNext,
        setPageIndex,
    } = props;

    const isGoogle = campaignData?.campaignTypeId === 1;
    const isProgrammatic = campaignData?.campaignTypeId === 26;
    const isMobile = campaignData?.campaignTypeId === 2;
    const [doesMatch, setDoesMatch] = useState(false);

    const { data } = useRequest('/GetAllPontiacCreativeBannerSizes');
    const { data: creativeTypesData } = useRequest('/GetAllPontiacCreativeTypes');

    const handlePreviewIcon = (fileObject) => {
        const { type } = fileObject.file;
        if (type.startsWith('video/') || type.startsWith('audio/')) {
            return (
                <video width="400" controls>
                    <source src={URL.createObjectURL(fileObject.file)} type="video/mp4" />
                </video>
            );
        } else {
            return (
                <img
                    style={{ objectFit: 'contain' }}
                    width="250px"
                    height="200px"
                    src={fileObject.data}
                    alt="ad"
                />
            );
        }
    };

    const processImageAndType = (width, height, fileType) => {
        if (
            isMobile
            // && width === 300 && height === 250
        ) {
            setDoesMatch(true);
        } else {
            setDoesMatch(false);
        }

        if (isProgrammatic) {
            if (data && Array.isArray(data)) {
                const match = data.find((size) => size.width === width && size.height === height);

                if (match) {
                    const matchedSizeId = match.pontiacCreativeBannerSizeId;
                    setDoesMatch(true);
                    setCampaignData((prevCampaignData) => ({
                        ...prevCampaignData,
                        file: {
                            ...prevCampaignData.file,
                            pontiacCreativeBannerSizeId: matchedSizeId,
                        },
                    }));
                } else {
                    setDoesMatch(false);
                    setCampaignData((prevCampaignData) => ({
                        ...prevCampaignData,
                        file: {
                            ...prevCampaignData.file,
                            pontiacCreativeBannerSizeId: 'n/a',
                        },
                    }));
                }
            }

            if (creativeTypesData) {
                const foundType = creativeTypesData.find(
                    (item) => item.pontiacAPICode === fileType
                );

                setCampaignData((prevCampaignData) => ({
                    ...prevCampaignData,
                    file: {
                        ...prevCampaignData.file,
                        creativeTypeId: foundType ? foundType.pontiacCreativeTypeId : 'n/a',
                        creativeTypeName: foundType ? foundType.pontiacCreativeTypeName : 'n/a',
                    },
                }));
            }
        }
    };

    const getImageDimensions = (file) => {
        const reader = new FileReader();
        reader.onload = function () {
            const img = new Image();
            img.onload = function () {
                setCampaignData({
                    ...campaignData,
                    file: {
                        ...campaignData.file,
                        fileName: file.name,
                        file,
                        width: img.width,
                        height: img.height,
                        fileType: 'image',
                        base64: reader.result,
                    },
                });
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    };

    const getAudioDimensions = (file) => {
        setCampaignData({
            ...campaignData,
            file: {
                ...campaignData.file,
                file,
                width: 0,
                height: 0,
                fileType: 'audio',
                base64: '',
            },
        });
    };
    const getVideoDimensions = (file) => {
        setCampaignData({
            ...campaignData,
            file: {
                ...campaignData.file,
                file,
                width: 0,
                height: 0,
                fileType: 'video',
                base64: '',
            },
        });
    };

    const getUploadedFileDimensions = (file) => {
        if (file && file.type.startsWith('image/')) {
            getImageDimensions(file);
        } else if (file && file.type.startsWith('audio/')) {
            getAudioDimensions(file);
        } else if (file && file.type.startsWith('video/')) {
            getVideoDimensions(file);
        } else {
            setCampaignData({
                ...campaignData,
                file: {
                    ...campaignData.file,
                    file,
                },
            });
        }
    };

    const handleFileUpload = (files) => {
        if (files && files.length > 0 && files[0]) {
            const file = files[0];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const isPNGorJPEG =
                fileExtension === 'png' || fileExtension === 'jpeg' || fileExtension === 'jpg';
            getUploadedFileDimensions(file);
            if (isPNGorJPEG) {
                setDoesMatch(true);
            } else {
                file;
                setDoesMatch(false);
            }
        }
    };

    const onFileNameChange = (e) => {
        setCampaignData({
            ...campaignData,
            file: {
                ...campaignData.file,
                fileName: e.target.value,
            },
        });
    };

    // const handleNavButtonNextSkip = () => {
    //     setPageIndex(7);
    // };
    // const determineRoute = () => {
    //     if (isProgrammatic || isMobile) {
    //         return handleNavButtonNextSkip();
    //     }

    //     return handleNavButtonNext();
    // };

    useEffect(() => {
        if (
            campaignData?.file.width &&
            campaignData?.file.height &&
            campaignData?.file.fileType
            // data &&
            // creativeTypesData
        ) {
            processImageAndType(
                campaignData.file.width,
                campaignData.file.height,
                campaignData.file.fileType
            );
        }
    }, [
        campaignData.file.width,
        campaignData.file.height,
        data,
        campaignData.file.fileType,
        creativeTypesData,
    ]);

    const determineImageError = () => {
        if (!isMobile) {
            if (campaignData?.file.file !== null && campaignData?.file.file !== undefined) {
                if (!doesMatch) {
                    const dimensionLabels = data.map((item) => item.pontiacCreativeBannerSizeLabel);
                    const dimensions = dimensionLabels.join(', ');

                    if (isProgrammatic) {
                        return (
                            <FileSizeErrorNotif>
                                {`The image you selected is either not an allowed image dimension or file type. We only allow images with the .png, .jpg, or .jpeg extensions. The dimension of this image is ${campaignData?.file.width}x${campaignData?.file.height}.For Programmatic ads, we only allow the following image dimensions: ${dimensions}`}
                            </FileSizeErrorNotif>
                        );
                    }

                    if (isMobile) {
                        return (
                            <FileSizeErrorNotif>{`The image you selected is either not an allowed image dimension or file type. We only allow images with the .png, .jpg, or .jpeg extensions. The dimension of this image is ${campaignData?.file.width}x${campaignData?.file.height}. For Mobile ads, we only allow the following image dimensions: '300x250'`}</FileSizeErrorNotif>
                        );
                    }
                }
            }
            return null;
        }
    };

    return (
        <UploadAdContainer>
            <Title>Upload your Ad</Title>
            <br />

            <UploadAdSection>
                {/* <StyledTextField
                    id="file-name"
                    label="File Name"
                    value={campaignData?.file?.fileName}
                    onChange={(e) => onFileNameChange(e)}
                    variant="outlined"
                    error={campaignData?.file?.fileName === ''}
                /> */}
                <br />
                <UploadAdInput>
                    <DropzoneArea
                        onDelete={() =>
                            setCampaignData({
                                ...campaignData,
                                file: { file: null, fileName: '' },
                            })
                        }
                        getPreviewIcon={handlePreviewIcon}
                        clearOnUnmount={false}
                        filesLimit={1}
                        maxFileSize={isMobile ? 10000000 : 150000}
                        initialFiles={campaignData?.file?.file ? [campaignData?.file?.file] : []}
                        acceptedFiles={['video/*', 'audio/*', 'image/*']}
                        dropzoneText="Drag and drop your file here or click to upload."
                        onChange={(files) => handleFileUpload(files)}
                    />
                </UploadAdInput>

                {determineImageError()}
            </UploadAdSection>

            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={
                        isProgrammatic &&
                        (!campaignData?.file?.file || !campaignData?.file?.fileName || !doesMatch)
                        //         ||
                        // (isMobile && campaignData?.file?.file && !doesMatch)
                    }
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </UploadAdContainer>
    );
};

UploadAd.propTypes = {
    campaignData: propTypes.shape({
        file: propTypes.shape({
            file: propTypes.shape({ type: propTypes.string, path: propTypes.string }),
            width: propTypes.number,
            height: propTypes.number,
            fileName: propTypes.string,
            fileType: propTypes.string,
        }),
        campaignType: propTypes.string,
        campaignTypeName: propTypes.string,
        campaignTypeId: propTypes.number,
    }),
    setCampaignData: propTypes.func,
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    setPageIndex: propTypes.func,
};

UploadAd.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    setPageIndex: () => {},
};
export default UploadAd;
